import { ILanguage } from '../shared/types/common';

export const languages: ILanguage[] = [
  {
    id: 2,
    name: 'Հայերեն',
    url: 'hy',
    entity: 0,
    ordering: 1,
    default: 1,
  },
  {
    id: 1,
    name: 'English',
    url: 'en',
    entity: 0,
    ordering: 2,
    default: 0,
  },
] as const;
